// The delete-user dialog arms only when the admin has typed the account's
// email and business name exactly (case and spacing aside) and entered the
// admin password. The server checks the same things again (routes/admin.py).
const norm = (v: string | null | undefined) => (v || '').split(/\s+/).filter(Boolean).join(' ').toLowerCase();

export function canConfirmDelete(
  typed: { email: string; businessName: string; password: string },
  target: { email: string; business_name: string },
): boolean {
  return norm(typed.email) === norm(target.email)
    && norm(typed.businessName) === norm(target.business_name)
    && typed.password.length > 0;
}
